var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAllBounces = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64156 1.48684H4.28493C3.04759 1.48684 2.42892 1.48684 1.95632 1.72778C1.5406 1.93971 1.20262 2.27787 0.990803 2.69381C0.75 3.16667 0.75 3.78567 0.75 5.02368V11.2132C0.75 12.4512 0.75 13.0702 0.990803 13.543C1.20262 13.959 1.5406 14.2971 1.95632 14.5091C2.42892 14.75 3.04759 14.75 4.28493 14.75H10.4711C11.7084 14.75 12.3271 14.75 12.7997 14.5091C13.2154 14.2971 13.5534 13.959 13.7652 13.543C14.006 13.0702 14.006 12.4512 14.006 11.2132V8.85526M7.378 5.17105H10.3238V8.11842M9.95556 1.85526V0.75M12.8567 2.6368L13.6378 1.85526M13.6453 5.53947H14.75M0.75 9.11102C1.23012 9.1852 1.72201 9.22368 2.22289 9.22368C5.4532 9.22368 8.30985 7.62296 10.0437 5.17105",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAllBounces, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/all-bounces.f38a7d68.svg";
export { ForwardRef as ReactComponent };